export const addDecimal = amount => {
  const amt = parseFloat(amount).toFixed(2)
  const amtSplit = amt.toString().split('.')
  const updatedAmtUS = amtSplit[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return updatedAmtUS + '.' + amtSplit[1]
}
